module.exports = __webpack_public_path__ + "img/resetpasswordimage.f6c21234.svg";